import React from 'react';
import PropTypes from "prop-types";

const ModalDeleteSubject = ({ hideModalDelete, showDeleteSubjectModal, removeSubjectConfirmation, subjectId, subjectName}) => {
    return(
        <div
            className={`bootbox modal fade bootbox-confirm ${showDeleteSubjectModal && "in"}`}
            tabIndex="-1"
            role="dialog"
            style={{
                display: showDeleteSubjectModal ? "block": "none",
                paddingRight: 15
            }}
        >
            <div className="modal-dialog modal-md">
                <div className="modal-content">
                    <div className="modal-body">
                        <button
                            type="button"
                            className="bootbox-close-button close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            style={{marginTop: -10}}
                            onClick={() => hideModalDelete()}
                        >
                            ×
                        </button>
                        <div className="bootbox-body">
                            <div className="sp-10 font-16">
                                Do you really want to remove the subject "{subjectName}"?<br /><br />
                                This will also delete all chapters, lectures, and other content related to this subject.  This action is irreversable, which is why we're asking you to confirm your action.
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            data-bb-handler="cancel"
                            type="button"
                            className="btn btn-default"
                            onClick={() => hideModalDelete()}
                        >
                            CANCEL
                        </button>
                        <button
                            data-bb-handler="confirm"
                            type="button"
                            className="btn btn-danger"
                            onClick={() =>
                                {
                                    hideModalDelete();
                                    removeSubjectConfirmation(subjectId);
                                }
                            }
                        >
                            DELETE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ModalDeleteSubject.propTypes = {
    showDeleteSubjectModal: PropTypes.bool.isRequired,
    hideModalDelete: PropTypes.func.isRequired,
    removeSubjectConfirmation: PropTypes.func.isRequired,
    subjectId: PropTypes.any.isRequired
};

export default ModalDeleteSubject;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/ModalDeleteSubject.js